import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';

@Component({
  selector: 'app-card-error',
  templateUrl: './card-error.component.html',
  styleUrls: []
})
export class CardErrorComponent implements OnInit {

  isTitleEmpty = true;

  @Input() id = '';
  @Input() title = '';
  @Input() errorMessage = '';
  @Input() screenReaderText = '';
  @Input() control: UntypedFormControl;

  @Input() isSubmitted = false;

  @Output() isInvalidControl = new EventEmitter();

  ngOnInit() {
    this.isTitleEmpty = this.isEmpty(this.title);
  }

  isEmpty(text: string) {
    return text === undefined || text === null || text === '';
  }

  isFieldInvalid(): boolean {
    const invalid = this.isSubmitted && (this.control.invalid && this.control.touched);
    this.isInvalidControl.emit(invalid);
    return invalid;
  }
}
